import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { api } from "@/lib/api";

export const NewsletterSignup = ({ variant = "footer" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: email.trim() });
      toast.success(data.already ? "You're already on the list, patriot!" : "Almost there — check your inbox to confirm your email.");
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not subscribe. Please check your email and try again.");
    } finally {
      setLoading(false);
    }
  };

  if (variant === "footer") {
    return (
      <form onSubmit={submit} data-testid="newsletter-form-footer" className="flex flex-col sm:flex-row gap-2 mt-4 max-w-sm">
        <input
          type="email"
          required
          data-testid="newsletter-email-input-footer"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email"
          className="flex-1 bg-white/10 border border-white/20 text-white placeholder-white/40 px-4 py-2.5 text-sm rounded-none focus:outline-none focus:border-[#D90429] transition-colors duration-200"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit-footer"
          className="bg-[#D90429] text-white px-5 py-2.5 uppercase tracking-[0.15em] text-xs font-bold hover:bg-[#b0031f] transition-colors duration-200 active:scale-95 disabled:opacity-60 inline-flex items-center justify-center gap-2"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Subscribe"}
        </button>
      </form>
    );
  }

  // section variant (light background, larger)
  return (
    <form onSubmit={submit} data-testid="newsletter-form-section" className="flex flex-col sm:flex-row gap-3 mt-8 max-w-lg mx-auto w-full">
      <input
        type="email"
        required
        data-testid="newsletter-email-input-section"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        className="flex-1 border-2 border-[#0A1128] px-5 py-4 text-base rounded-none focus:outline-none focus:border-[#D90429] transition-colors duration-200"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit-section"
        className="bg-[#D90429] text-white px-8 py-4 uppercase tracking-[0.15em] text-sm font-bold hover:bg-[#b0031f] transition-colors duration-200 active:scale-95 disabled:opacity-60 inline-flex items-center justify-center gap-2 whitespace-nowrap"
      >
        {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Send className="w-4 h-4" /> Sign Up</>}
      </button>
    </form>
  );
};
